import React from 'react';
import PropTypes from 'prop-types';
import moment from "moment"

const nf2 = new Intl.NumberFormat('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
}); 

const format = new Intl.NumberFormat('es-MX'); 


export default function TableMovementItem({ item }) {

    const {
        id,
        c_provider_id,
        mov_date,
        fecha,
        deposit,
        retiro,
        balance,
        account_name,
        detalleTipo,
        description,
        folio
    } = item;

    return (
        <>
            <tr>
                <td className="text-end">
                    {fecha}
                </td>
                <td className="text-end">
                    {folio}
                </td>
                <td className="text-end">
                    {detalleTipo}
                </td>
                <td className="text-end">
                    { description }
                </td>
                <td className="text-right">
                    { format.format(retiro) }
                </td>
                <td className="text-right">
                    { format.format(deposit) }
                </td>
                <td className="text-right">
                    { nf2.format(balance) }
                </td>
            </tr>
        </>
    );
}

TableMovementItem.propTypes = {
    item: PropTypes.object
};